<template>

    <div>
        <page-title :title="$t('integrations.title')"></page-title>

        <div class="flex flex-col sm:flex-row md:mt-0 mb-4 sm:space-x-8 items-end">
            <div class="flex flex-row flex-1 w-full">
                <search-bar class="flex-1" :placeholder="$t('integrations.search')" v-model="form.search"></search-bar>
            </div>
            <sort v-model="form.sort" :options="sortOptions" class="mt-3 sm:mt-0"></sort>
        </div>
        <pagination class="my-6" :links="integrations.links" prefix="t"></pagination>

        <div class="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                <tr>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('integrations.id') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('integrations.name') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('integrations.code') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('integrations.integration') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('integrations.active') }}
                    </th>
                </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="entry in integrations.data" :key="entry.id">
                    <td class="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {{ entry.id }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <TextLink :href="route('settings.integrations.edit', entry.id)">
                            {{ entry.name }}
                        </TextLink>
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ entry.code }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ entry.integration }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <checkbox :checked="entry.active" disabled></checkbox>
                    </td>
                </tr>
                </tbody>
            </table>


        </div>

        <pagination class="mt-6" :links="integrations.links" prefix="b"></pagination>

    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import PageTitle from "@/Shared/Components/PageTitle";
import {MagnifyingGlassIcon} from "@heroicons/vue/24/outline";
import SearchBar from "@/Shared/Components/SearchBar";
import Pagination from "@/Shared/Components/Pagination";
import {mapValues, pickBy, throttle} from "lodash";
import SwitchInput from "@/Shared/Components/SwitchInput";
import {ref} from "vue";
import Checkbox from "@/Jetstream/Checkbox";
import Sort from "@/Shared/Components/Sort";
import {i18n} from "@/app";
import FilterMenu from "@/Shared/Components/FilterMenu";
import TextLink from "@/Shared/Components/TextLink";

const {t} = i18n.global;

const sortOptions = [
    {id: 'id', name: t('integrations.id')},
    {id: 'name', name: t('integrations.name')},
    {id: 'code', name: t('integrations.code')},
    {id: 'integration', name: t('integrations.integration')},
]

export default {
    components: {
        TextLink,
        FilterMenu,
        Checkbox,
        Pagination,
        SearchBar,
        PageTitle,
        MagnifyingGlassIcon,
        SwitchInput,
        Sort,
    },
    layout: AppLayout,
    props: ['integrations', 'filter', 'sort'],
    setup(props) {
        const form = ref({
            search: props.filter.search,
            sort: props.sort
        })
        return {
            form,
            sortOptions
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                let query = {
                    "filter[search]": this.form.search,
                    "sort": this.form.sort
                };

                this.$inertia.get(this.route("settings.integrations.index"), pickBy(query), {
                    preserveState: true
                });
            }, 700)
        }
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null);
        }
    },

}
</script>

<style scoped>

</style>
